// Centralized Zillow listings to make add/remove edits easy.
import house1 from '../sold1_Canton.png';
import sold1 from '../sold1_Warren.png';
import forsale1 from '../forsale1_SterlingHeights.png';
import forsale2 from '../forsale2_SterlingHeights.png';
import sold2 from '../sold2_CommerceTwnship.png';
import sold3 from '../sold3_troy.png';
import seemore from '../seemore.jpg';

const zillowListings = [
  {
    id: 'sold-canton',
    title: 'Modern Family Home - Sold',
    location: 'Canton, MI',
    description: 'A beautiful family home with spacious interiors.',
    image: house1,
    represented: 'Seller',
    status: 'Sold',
    zillowLink: 'https://www.zillow.com/homedetails/1427-Walnut-Ridge-Cir-Canton-MI-48187/88657183_zpid/?',
  },
  {
    id: 'sold-troy',
    title: 'Modern Family Home - Sold',
    location: 'Troy, MI',
    description: '',
    image: sold3,
    represented: 'Buyer',
    status: 'Sold',
    zillowLink: 'https://www.zillow.com/homedetails/5064-Shrewsbury-Dr-Troy-MI-48085/24514950_zpid/?',
  },
  {
    id: 'sold-warren',
    title: 'Family Home - Sold',
    location: 'Warren, MI',
    description: '',
    image: sold1,
    represented: 'Seller',
    status: 'Sold',
    zillowLink: 'https://www.zillow.com/homedetails/29717-Van-Laan-Dr-Warren-MI-48092/83527022_zpid/?mmlb=g,0',
  },
  {
    id: 'active-viceroy-sterling-heights',
    title: 'Modern Family Home - On Market',
    location: 'Sterling Heights, MI',
    description: 'A beautiful family home with spacious interiors.',
    image: forsale1,
    represented: 'Seller',
    status: 'On Market',
    zillowLink: 'https://www.zillow.com/homedetails/34556-Viceroy-Dr-Sterling-Heights-MI-48310/83645491_zpid/',
  },
  {
    id: 'active-clifford-sterling-heights',
    title: 'Modern Family Home - On Market',
    location: 'Sterling Heights, MI',
    description: '',
    image: forsale2,
    represented: 'Seller',
    status: 'On Market',
    zillowLink: 'https://www.zillow.com/homedetails/36228-Clifford-Dr-Sterling-Heights-MI-48312/83458328_zpid/',
  },
  {
    id: 'sold-commerce-twp',
    title: 'Modern Family Home - Sold',
    location: 'Commerce Township, MI',
    description: '',
    image: sold2,
    represented: 'Buyer',
    status: 'Sold',
    zillowLink: 'https://www.zillow.com/homedetails/2710-Tulip-Way-Commerce-Township-MI-48382/2056363275_zpid/?',
  },
  {
    id: 'see-more',
    title: 'See More..',
    location: 'More listings on Zillow.',
    description: '',
    image: seemore,
    represented: '50+ families',
    status: 'CTA',
    zillowLink: 'https://www.zillow.com/profile/realtorganesh',
  },
];

export default zillowListings;
